import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { FormGroup, FormControl } from '@angular/forms';
import { Strategia } from 'src/app/core/models/entities/strategia';

@Component({
  selector: 'video-dialog',
  templateUrl: './video-dialog.component.html',
  styleUrls: ['./video-dialog.component.scss']
})
export class VideoDialogComponent implements OnInit, OnDestroy {

  displayModal: boolean;
  subscriptions: Subscription = new Subscription();

  videoUrl: string;
  title: string;

  @Output() onSubmit: EventEmitter<any> = new EventEmitter<any>();

  constructor() {
  }

  ngOnInit(): void {
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  openDialog(videoUrl: string, title: string) {
    this.videoUrl = videoUrl;
    this.title = title;
    this.displayModal = true;
  }

  closeDialog() {
    this.displayModal = false;
  }

}